// ここにメニュー階層のデータを記載する
const Dashboard = () => import("@/views/Dashboard");
const Language = () => import("@/views/properties/Language");
const Maintenance = () => import("@/views/properties/Maintenance");
const Notice = () => import("@/views/properties/Notice");
const Mobile = () => import("@/views/properties/Mobile");
const QRCode = () => import("@/views/properties/QRCode");
const Link = () => import("@/views/properties/Link");
const Mail = () => import("@/views/properties/Mail");
const Receipt = () => import("@/views/properties/Receipt");
const PriceList = () => import("@/views/master/PriceList");
const PriceEdit = () => import("@/views/master/PriceEdit");
const DisplayLimitEdit = () => import("@/views/master/DisplayLimitEdit");
const DisplayLimitList = () => import("@/views/master/DisplayLimitList");
const GroupList = () => import("@/views/master/GroupList");
const GroupEdit = () => import("@/views/master/GroupEdit");
const OptionsList = () => import("@/views/master/OptionsList");
const OptionsEdit = () => import("@/views/master/OptionsEdit");
const TicketList = () => import("@/views/master/TicketList");
const TicketEdit = () => import("@/views/master/TicketEdit");
const CategoryList = () => import("@/views/master/CategoryList");
const CategoryEdit = () => import("@/views/master/CategoryEdit");
const CodeTicketFacilitiesList = () =>
  import("@/views/master/CodeTicketFacilitiesList");
const CodeTicketFacilitiesEdit = () =>
  import("@/views/master/CodeTicketFacilitiesEdit");
const CodeTicketList = () => import("@/views/master/CodeTicketList");
const CodeTicketEdit = () => import("@/views/master/CodeTicketEdit");
const CompanyList = () => import("@/views/master/CompanyList");
const CompanyEdit = () => import("@/views/master/CompanyEdit");
const DocomoBikeShareTicketList = () =>
  import("@/views/maas/DocomoBikeShareTicketList");
const DocomoBikeShareTicketEdit = () =>
  import("@/views/maas/DocomoBikeShareTicketEdit");
const ExternalPrimaryLinkList = () => import("@/views/link/PrimaryList");
const ExternalPrimaryLinkEdit = () => import("@/views/link/PrimaryEdit");
const ExternalSecondaryLinkList = () => import("@/views/link/SecondaryList");
const ExternalSecondaryLinkEdit = () => import("@/views/link/SecondaryEdit");
const FacilitiesList = () => import("@/views/master/FacilitiesList");
const FacilitiesEdit = () => import("@/views/master/FacilitiesEdit");
const HolidayList = () => import("@/views/master/HolidayList");
const HolidayEdit = () => import("@/views/master/HolidayEdit");
const GateList = () => import("@/views/master/GateList");
const GateEdit = () => import("@/views/master/GateEdit");
const AllocationRatioList = () => import("@/views/master/AllocationRatioList.vue")
const AllocationRatioEdit = () => import("@/views/master/AllocationRatioEdit.vue")
const RouteSearch = () => import("@/views/maas/RouteSearch");
const RouteSearchEmulator = () => import("@/views/maas/RouteSearchEmulator");
const RouteSearchFilterList = () =>
  import("@/views/maas/RouteSearchFilterList");
const RouteSearchFilterEdit = () =>
  import("@/views/maas/RouteSearchFilterEdit");
const RouteTicketList = () => import("@/views/maas/RouteTicketList");
const RouteTicketEdit = () => import("@/views/maas/RouteTicketEdit");
const DistributionTicketList = () => import("@/views/distribution/TicketList");
const DistributionTicketEdit = () => import("@/views/distribution/TicketEdit");
const DistributionExecute = () => import("@/views/distribution/Execute");
const DistributionHistory = () => import("@/views/distribution/History");
const StationList = () => import("@/views/maas/StationList");
const StationListEdit = () => import("@/views/maas/StationListEdit");
const UserList = () => import("@/views/user/UserList");
const UserDetail = () => import("@/views/user/UserDetail");
const OrderDetail = () => import("@/views/user/OrderDetail");
const TicketDetail = () => import("@/views/user/TicketDetail");
const GrantAttribute = () => import("@/views/user/GrantAttribute");
const AttributeList = () => import("@/views/user/AttributeList");
const AttributeEdit = () => import("@/views/user/AttributeEdit");
const AdministratorList = () => import("@/views/admin/AdministratorList");
const AdministratorEdit = () => import("@/views/admin/AdministratorEdit");
const ReportAll = () => import("@/views/report/ReportAll");
const ReportCompany = () => import("@/views/report/ReportCompany");
const ReportTickets = () => import("@/views/report/ReportTickets");
const ReportCodeTicketing = () => import("@/views/report/ReportCodeTicketing");
const ReportGate = () => import("@/views/report/ReportGate");
const MailBulkSend = () => import("@/views/mail/BulkSend");
const MailHistory = () => import("@/views/mail/History");
const SearchTicket = () => import("@/views/search/SearchTicket");
const SearchOrder = () => import("@/views/search/SearchOrder");
const SearchReceipt = () => import("@/views/search/SearchReceipt");
const Log = () => import("@/views/log/Log");

export default [
  {
    kind: "menu",
    path: "/",
    name: "ダッシュボード",
    icon: "mdi-view-dashboard",
    view: Dashboard,
  },
  {
    kind: "group",
    name: "プロパティ",
    icon: "mdi-square-edit-outline",
    active: "true",
    menu: [
      {
        kind: "menu",
        path: "/language",
        name: "言語設定",
        icon: "mdi-translate",
        view: Language,
      },
      {
        kind: "menu",
        path: "/maintenance",
        name: "メンテナンス",
        icon: "mdi-tools",
        view: Maintenance,
      },
      {
        kind: "menu",
        path: "/notice",
        name: "お知らせ",
        icon: "mdi-newspaper",
        view: Notice,
      },
      {
        kind: "menu",
        path: "/mobile",
        name: "モバイルアプリ",
        icon: "mdi-cellphone-information",
        view: Mobile,
      },
      {
        kind: "menu",
        path: "/qrcode",
        name: "QRコード",
        icon: "mdi-qrcode",
        view: QRCode,
      },
      {
        kind: "menu",
        path: "/link",
        name: "リンク",
        icon: "mdi-link",
        view: Link,
      },
      {
        kind: "menu",
        path: "/mail",
        name: "メール",
        icon: "mdi-email",
        view: Mail,
      },
      {
        kind: "menu",
        path: "/receipt",
        name: "領収書",
        icon: "mdi-receipt",
        view: Receipt,
      },
    ],
  },
  {
    kind: "group",
    name: "マスタ管理",
    icon: "mdi-file-table-box-multiple-outline",
    menu: [
      {
        kind: "menu",
        path: "/price",
        name: "価格区分",
        icon: "mdi-square-inc-cash",
        view: PriceList,
      },
      {
        kind: "route",
        path: "/price/:id",
        name: "価格区分編集",
        icon: "",
        view: PriceEdit,
      },
      {
        kind: "route",
        path: "/price/:id/:from",
        name: "価格区分編集",
        icon: "",
        view: PriceEdit,
      },
      {
        kind: "menu",
        path: "/company",
        name: "事業者",
        icon: "mdi-account-tie",
        view: CompanyList,
      },
      {
        kind: "route",
        path: "/company/:id",
        name: "事業者編集",
        icon: "",
        view: CompanyEdit,
      },
      {
        kind: "route",
        path: "/company/:id/:from",
        name: "事業者編集",
        icon: "",
        view: CompanyEdit,
      },
      {
        kind: "menu",
        path: "/facilities",
        name: "施設",
        icon: "mdi-office-building",
        view: FacilitiesList,
      },
      {
        kind: "route",
        path: "/facilities/:id",
        name: "施設編集",
        icon: "",
        view: FacilitiesEdit,
      },
      {
        kind: "route",
        path: "/facilities/:id/:from",
        name: "施設編集",
        icon: "",
        view: FacilitiesEdit,
      },
      {
        kind: "menu",
        path: "/holiday",
        name: "祝日",
        icon: "mdi-calendar-today",
        view: HolidayList,
      },
      {
        kind: "route",
        path: "/holiday/:id",
        name: "祝日編集",
        icon: "",
        view: HolidayEdit,
      },
      {
        kind: "route",
        path: "/holiday/:id/:from",
        name: "祝日編集",
        icon: "",
        view: HolidayEdit,
      },
      {
        kind: "menu",
        path: "/category",
        name: "チケット分類",
        icon: "mdi-folder-multiple",
        view: CategoryList,
      },
      {
        kind: "route",
        path: "/category/:id",
        name: "チケット分類編集",
        icon: "",
        view: CategoryEdit,
      },
      {
        kind: "route",
        path: "/category/:id/:from",
        name: "チケット分類編集",
        icon: "",
        view: CategoryEdit,
      },
      {
        kind: "menu",
        path: "/group",
        name: "チケットグループ",
        icon: "mdi-folder-open",
        view: GroupList,
      },
      {
        kind: "route",
        path: "/group/:id",
        name: "チケットグループ編集",
        icon: "",
        view: GroupEdit,
      },
      {
        kind: "route",
        path: "/group/:id/:from",
        name: "チケットグループ編集",
        icon: "",
        view: GroupEdit,
      },
      {
        kind: "menu",
        path: "/options",
        name: "オプショングループ",
        icon: "mdi-folder-open",
        view: OptionsList,
      },
      {
        kind: "route",
        path: "/options/:id",
        name: "オプショングループ編集",
        icon: "",
        view: OptionsEdit,
      },
      {
        kind: "route",
        path: "/options/:id/:from",
        name: "オプショングループ編集",
        icon: "",
        view: OptionsEdit,
      },
      {
        kind: "menu",
        path: "/ticket",
        name: "チケット",
        icon: "mdi-ticket-confirmation",
        view: TicketList,
      },
      {
        kind: "route",
        path: "/ticket/:id",
        name: "チケット編集",
        icon: "",
        view: TicketEdit,
      },
      {
        kind: "route",
        path: "/ticket/:id/:from",
        name: "チケット編集",
        icon: "",
        view: TicketEdit,
      },
      {
        kind: "menu",
        path: "/displayLimit",
        name: "券面表示制限",
        icon: "mdi-bus-clock",
        view: DisplayLimitList,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.ticketDisplayLimit",
      },
      {
        kind: "route",
        path: "/displayLimit/:id",
        name: "券面表示制限編集",
        icon: "",
        view: DisplayLimitEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.ticketDisplayLimit",
      },
      {
        kind: "route",
        path: "/displayLimit/:id/:from",
        name: "券面表示制限編集",
        icon: "",
        view: DisplayLimitEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.ticketDisplayLimit",
      },
      {
        kind: "menu",
        path: "/codeTicketFacilities",
        name: "コード発券施設",
        icon: "mdi-qrcode-scan",
        view: CodeTicketFacilitiesList,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.codeTicketing",
      },
      {
        kind: "route",
        path: "/codeTicketFacilities/:id",
        name: "コード発券施設編集",
        icon: "",
        view: CodeTicketFacilitiesEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.codeTicketing",
      },
      {
        kind: "route",
        path: "/codeTicketFacilities/:id/:from",
        name: "コード発券施設編集",
        icon: "",
        view: CodeTicketFacilitiesEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.codeTicketing",
      },
      {
        kind: "menu",
        path: "/codeTicket",
        name: "コード発券チケット",
        icon: "mdi-ticket-confirmation",
        view: CodeTicketList,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.codeTicketing",
      },
      {
        kind: "route",
        path: "/codeTicket/:id",
        name: "コード発券チケット編集",
        icon: "",
        view: CodeTicketEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.codeTicketing",
      },
      {
        kind: "route",
        path: "/codeTicket/:id/:from",
        name: "コード発券チケット編集",
        icon: "",
        view: CodeTicketEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.codeTicketing",
      },
      {
        kind: "menu",
        path: "/gate",
        name: "ゲート",
        icon: "mdi-exit-run",
        view: GateList,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.gatePass",
      },
      {
        kind: "route",
        path: "/gate/:id",
        name: "ゲート編集",
        icon: "",
        view: GateEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.gatePass",
      },
      {
        kind: "route",
        path: "/gate/:id/:from",
        name: "ゲート編集",
        icon: "",
        view: GateEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.gatePass",
      },
      {
        kind: "menu",
        path: "/allocationRatios",
        name: "拡張配分比率",
        icon: "mdi-square-inc-cash",
        view: AllocationRatioList,
      },
      {
        kind: "route",
        path: "/allocationRatios/:ticketID/:identifier",
        name: "拡張配分比率編集",
        icon: "",
        view: AllocationRatioEdit,
      },
    ],
  },
  {
    kind: "group",
    name: "MaaS管理",
    icon: "mdi-car",
    menu: [
      {
        kind: "menu",
        path: "/shareCycleTicket",
        name: "シェアサイクル",
        icon: "mdi-bicycle",
        view: DocomoBikeShareTicketList,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.docomoBikeShare",
      },
      {
        kind: "route",
        path: "/shareCycleTicket/:id",
        name: "シェアサイクル編集",
        icon: "",
        view: DocomoBikeShareTicketEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.docomoBikeShare",
      },
      {
        kind: "route",
        path: "/shareCycleTicket/:id/:from",
        name: "シェアサイクル編集",
        icon: "",
        view: DocomoBikeShareTicketEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.docomoBikeShare",
      },
      {
        kind: "menu",
        path: "/routeSearch",
        name: "経路検索(設定)",
        icon: "mdi-map-marker-distance",
        view: RouteSearch,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "menu",
        path: "/routeSearchFilter",
        name: "経路検索(フィルタ)",
        icon: "mdi-map-marker-alert-outline",
        view: RouteSearchFilterList,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "route",
        path: "/routeSearchFilter/:id",
        name: "経路検索(フィルタ)編集",
        icon: "",
        view: RouteSearchFilterEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "route",
        path: "/routeSearchFilter/:id/:from",
        name: "経路検索(フィルタ)編集",
        icon: "",
        view: RouteSearchFilterEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "menu",
        path: "/RouteSearchEmulator",
        name: "経路検索(エミュレータ)",
        icon: "mdi-map-marker-path",
        view: RouteSearchEmulator,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "menu",
        path: "/stationList",
        name: "駅リスト",
        icon: "mdi-train",
        view: StationList,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "route",
        path: "/stationList/:id",
        name: "駅リスト編集",
        icon: "",
        view: StationListEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "route",
        path: "/stationList/:id/:from",
        name: "駅リスト編集",
        icon: "",
        view: StationListEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "menu",
        path: "/routeTicket",
        name: "経路関連チケット",
        icon: "mdi-card-search-outline",
        view: RouteTicketList,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "route",
        path: "/routeTicket/:id",
        name: "経路関連チケット編集",
        icon: "",
        view: RouteTicketEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
      {
        kind: "route",
        path: "/routeTicket/:id/:from",
        name: "経路関連チケット編集",
        icon: "",
        view: RouteTicketEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.routeSearch",
      },
    ],
  },

  {
    kind: "group",
    name: "外部リンク",
    icon: "mdi-link-box-outline",
    menu: [
      {
        kind: "menu",
        path: "/externalPrimaryLink",
        name: "リンク(第1階層)",
        icon: "mdi-link-box-outline",
        view: ExternalPrimaryLinkList,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.bannerLink",
      },
      {
        kind: "route",
        path: "/externalPrimaryLink/:id",
        name: "リンク(第1階層)編集",
        icon: "mdi-account",
        view: ExternalPrimaryLinkEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.bannerLink",
      },
      {
        kind: "route",
        path: "/externalPrimaryLink/:id/:from",
        name: "リンク(第1階層)編集",
        icon: "mdi-account",
        view: ExternalPrimaryLinkEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.bannerLink",
      },
      {
        kind: "menu",
        path: "/externalSecondaryLink",
        name: "リンク(第2階層)",
        icon: "mdi-file-link-outline",
        view: ExternalSecondaryLinkList,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.bannerLink",
      },
      {
        kind: "route",
        path: "/externalSecondaryLink/:id",
        name: "リンク(第2階層)編集",
        icon: "mdi-account",
        view: ExternalSecondaryLinkEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.bannerLink",
      },
      {
        kind: "route",
        path: "/externalSecondaryLink/:id/:from",
        name: "リンク(第2階層)編集",
        icon: "mdi-account",
        view: ExternalSecondaryLinkEdit,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.bannerLink",
      },
    ],
  },
  {
    kind: "group",
    name: "チケット配布",
    icon: "mdi-email-send",
    menu: [
      {
        kind: "menu",
        path: "/distribution/ticket",
        name: "配布用チケット",
        icon: "mdi-ticket",
        view: DistributionTicketList,
        cond:
          "this.$store.state.customize.canUseCustomize.nec.ticketDistribution",
      },
      {
        kind: "route",
        path: "/distribution/ticket/:id",
        name: "配布用チケット編集",
        icon: "",
        view: DistributionTicketEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.nec.ticketDistribution",
      },
      {
        kind: "route",
        path: "/distribution/ticket/:id/:from",
        name: "配布用チケット編集",
        icon: "",
        view: DistributionTicketEdit,
        cond:
          "this.$store.state.customize.canUseCustomize.nec.ticketDistribution",
      },

      {
        kind: "menu",
        path: "/distribution/execute",
        name: "チケット配布",
        icon: "mdi-email-send",
        view: DistributionExecute,
        cond:
          "this.$store.state.customize.canUseCustomize.nec.ticketDistribution",
      },
      {
        kind: "menu",
        path: "/distribution/history",
        name: "チケット配布履歴",
        icon: "mdi-history",
        view: DistributionHistory,
        cond:
          "this.$store.state.customize.canUseCustomize.nec.ticketDistribution",
      },
    ],
  },
  {
    kind: "group",
    name: "ユーザー管理",
    icon: "mdi-account-multiple",
    menu: [
      {
        kind: "menu",
        path: "/user",
        name: "ユーザー検索",
        icon: "mdi-account-multiple",
        view: UserList,
      },
      {
        kind: "route",
        path: "/user/:id",
        name: "ユーザー詳細",
        icon: "",
        view: UserDetail,
      },
      {
        kind: "route",
        path: "/user/:id/order/:oid",
        name: "取引詳細",
        icon: "",
        view: OrderDetail,
      },
      {
        kind: "route",
        path: "/user/:id/order/:oid/ticket/:tid",
        name: "チケット詳細",
        icon: "",
        view: TicketDetail,
      },
      {
        kind: "menu",
        path: "/attribute",
        name: "ユーザー属性",
        icon: "mdi-tag",
        view: AttributeList,
      },
      {
        kind: "route",
        path: "/attribute/:id",
        name: "ユーザー属性編集",
        icon: "mdi-tag",
        view: AttributeEdit,
      },
      {
        kind: "route",
        path: "/attribute/:id/:from",
        name: "ユーザー属性編集",
        icon: "mdi-tag",
        view: AttributeEdit,
      },
      {
        kind: "menu",
        path: "/grantAttribute",
        name: "属性付与",
        icon: "mdi-tag-plus",
        view: GrantAttribute,
      },
    ],
  },
  {
    kind: "menu",
    path: "/admin",
    name: "管理者",
    icon: "mdi-account",
    view: AdministratorList,
  },
  {
    kind: "route",
    path: "/admin/:id",
    name: "管理者編集",
    icon: "mdi-account",
    view: AdministratorEdit,
  },
  {
    kind: "group",
    name: "レポート",
    icon: "mdi-note",
    menu: [
      {
        kind: "menu",
        path: "/report",
        name: "全体",
        icon: "mdi-note",
        view: ReportAll,
      },
      {
        kind: "menu",
        path: "/reportCompany",
        name: "事業者別",
        icon: "mdi-account-tie",
        view: ReportCompany,
      },
      {
        kind: "menu",
        path: "/reportTickets",
        name: "チケット別",
        icon: "mdi-ticket-confirmation",
        view: ReportTickets,
      },
      {
        kind: "menu",
        path: "/reportCodeTicketing",
        name: "コード発券",
        icon: "mdi-qrcode-scan",
        view: ReportCodeTicketing,
        cond:
          "this.$store.state.customize.canUseCustomize.hiroden.codeTicketing",
      },
      {
        kind: "menu",
        path: "/reportGate",
        name: "ゲート通過",
        icon: "mdi-exit-run",
        view: ReportGate,
        cond: "this.$store.state.customize.canUseCustomize.hiroden.gatePass",
      },
    ],
  },
  {
    kind: "group",
    name: "一括メール送信",
    icon: "mdi-email-send",
    menu: [
      {
        kind: "menu",
        path: "/mail/bulkSend",
        name: "メール送信",
        icon: "mdi-email-send",
        view: MailBulkSend,
      },
      {
        kind: "menu",
        path: "/mail/history",
        name: "送信履歴",
        icon: "mdi-history",
        view: MailHistory,
      },
    ],
  },
  {
    kind: "menu",
    path: "/searchTicket",
    name: "チケット検索",
    icon: "mdi-card-search-outline",
    view: SearchTicket,
    cond: "this.$store.state.customize.canUseCustomize.hiroden.searchTicket",
  },
  {
    kind: "route",
    path: "/searchTicket/:ticketID/:status/:startDate/:endDate",
    name: "チケット検索",
    icon: "",
    view: SearchTicket,
  },
  {
    kind: "route",
    path: "/searchTicket/:ticketID/:status/:startDate/:endDate/:activateDate",
    name: "チケット検索",
    icon: "",
    view: SearchTicket,
  },
  {
    kind: "menu",
    path: "/searchOrder",
    name: "取引検索",
    icon: "mdi-shopping-search",
    view: SearchOrder,
    cond: "this.$store.state.customize.canUseCustomize.hiroden.searchSales",
  },
  {
    kind: "route",
    path: "/searchOrder/:status/:startDate/:endDate",
    name: "取引検索",
    icon: "",
    view: SearchOrder,
  },
  {
    kind: "menu",
    path: "/searchReceipt",
    name: "領収書検索",
    icon: "mdi-receipt",
    view: SearchReceipt,
  },
  {
    kind: "menu",
    path: "/log",
    name: "ログ管理",
    icon: "mdi-console",
    view: Log,
  },
];
